export const strHash = (s: string): number => {
  return Math.abs(
    s.split('').reduce(
      function(a, b) {
        const A = ((a << 5) - a) + b.charCodeAt(0);
        return A & A;
      }, 0)
  );
};
